import { CSSProperties, useMemo } from 'react';
import { Hotspot } from '.';

const useHotspotStyles = (hotspot?: Hotspot) => {
  const styles = useMemo<CSSProperties>(() => {
    const { x, y } = hotspot || {};
    if (typeof x !== 'number' || typeof y !== 'number') {
      return {};
    }
    return {
      objectPosition: `${x * 100}% ${y * 100}%`,
    };
  }, [hotspot]);

  return styles;
};

export default useHotspotStyles;
